import {gql} from "@irati/utils/gql"
import fullBranding from "@irati/brand/services/fragments/fullBranding"

export default gql`
  fragment fullUnauthedBusiness on UnauthedBusiness {
    uuid
    branding {
      ...fullBranding
    }
    businessName
    subdomain
    loginPageSsoButtonText
    showPasswordLogin
    showSsoLogin
    selfRegistrations
  }
  ${fullBranding}
`
